module.exports = __webpack_public_path__ + "static/00019.474a117e.jpg";